import { defineComponent as _defineComponent } from 'vue'
import { ref, onUnmounted, computed, onMounted } from "vue";
  import store from "@/store";
  import router from "../../router/index";
  import HeaderCustomer from "@/components/HeaderCustomer.vue";
  import EOIInfoMessage from "@/components/eoi/EOIInfoMessage.vue";
  import LotCard from "@/components/eoi/LotCard.vue";
  import { formatStripePrice } from "@/helpers/transformation/price";
  import { EstateInterface } from "@/types/EstateInterface";
  import { EoiStatus } from "@/enums/EoiStatus";
  import { POSITION, useToast } from "vue-toastification";
  import CheckboxInput from "@/components/ui/input/CheckboxInput.vue";
  import { LotInterface } from "@/types/LotInterface";
  import {
    changePrimaryColor,
    resetPrimaryColor,
  } from "@/helpers/customer/changePrimaryColor";
  import AttentionModal from "@/components/ui/modals/AttentionModal.vue";
  import { isLogged } from "@/features/useUser";
  import getUserRole from "@/helpers/getUserRole";
  import { changePrimaryColorEoiViews } from "@/helpers/eoi/changePrimaryColorEoiViews";

  const stripeFee = 3018;
  
export default /*@__PURE__*/_defineComponent({
  __name: 'EOIRequestPayment',
  setup(__props, { expose: __expose }) {
  __expose();

  const toast = useToast();
  const estateId = ref(router.currentRoute.value.params.estateId);
  const lotId = ref(router.currentRoute.value.params.lotId);
  const eoiId = ref(router.currentRoute.value.params.eoiId);
  const businessId = ref(
    (router.currentRoute.value.query?.businessId as string) ?? null
  );

  const eoiInfo = computed(() => store.state.eoi.eoiObj);
  const estate = ref<EstateInterface | Record<string, unknown>>({});
  const loading = ref(false);
  const isAgree = ref(false);
  const lot = ref<LotInterface | null>(null);
  const isPaymentAllowed = ref(true);
  const showAttentionModal = ref(false);
  const { isCustomer } = getUserRole();

  onMounted(() => {
    store.dispatch("estate/getEstate", estateId.value).then((res) => {
      estate.value = res.data;
      changePrimaryColorEoiViews(res.data, businessId.value);
    });
    const action = isLogged() ? "getLot" : "getOpenLot";

    store.dispatch(`lot/${action}`, lotId.value).then((res) => {
      lot.value = res.data;
    });

    if (store.state.eoi.eoiObj?._id != eoiId.value) {
      store
        .dispatch("eoi/getEoiByIdAndSetToStore", eoiId.value)
        .then(() => checkEoiStatus());
    } else checkEoiStatus();

    store.dispatch("appSettings/getAppSettings").then((res) => {
      isPaymentAllowed.value = res?.data?.isPaymentAllowed;
    });
  });

  onUnmounted(() => {
    store.commit("eoi/resetEoiObj");
    resetPrimaryColor();
  });

  const pay = () => {
    if (isAgree.value) {
      if (!isPaymentAllowed.value) {
        showAttentionModal.value = true;
      } else {
        loading.value = true;
        // for test without payment
        /*store
        .dispatch("eoi/setEoiStatusPending", eoiId.value)
        .then(() => {
          router.push({
            name: "EOIRequestPaymentConfirmation",
            params: {
              estateId: estateId.value,
            },
          });
        })
        .catch(() => {
          toast.error("Something went wrong", { position: POSITION.TOP_LEFT });
        })
        .finally(() => (loading.value = false));*/
        const action =
          isLogged() && isCustomer.value
            ? "getEoiPaymentUrl"
            : "getEoiPaymentUrlForUnregisteredCustomer";

        store
          .dispatch(`eoi/${action}`, {
            landownerId: (estate.value as EstateInterface).landownerId._id,
            eoiId: eoiId.value,
            lotId: lotId.value,
            estateId: estateId.value,
            customerId: eoiInfo.value.customerId?._id,
          })
          .then((res) => {
            window.open(res.data, "_self");
          })
          .catch(() => {
            toast.error("Something went wrong", {
              position: POSITION.TOP_LEFT,
            });
            loading.value = false;
          });
      }
    }
  };

  function checkEoiStatus() {
    if (eoiInfo.value.status === EoiStatus.PENDING) {
      router.push({
        name: "EOIRequestPaymentConfirmation",
        params: {
          estateId: estateId.value,
          ...(businessId.value ? { businessId: businessId.value } : {}),
        },
      });
    }
  }
  function onBack() {
    const { backUrl } = router.currentRoute.value.params;

    if (backUrl) {
      router.push(backUrl as string);
    } else {
      router.push(
        `/estate/${estateId.value}/lot/${lotId.value}/eoi-request?eoiId=${eoiId.value}`
      );
    }
  }

const __returned__ = { toast, estateId, lotId, eoiId, businessId, eoiInfo, estate, loading, isAgree, lot, stripeFee, isPaymentAllowed, showAttentionModal, isCustomer, pay, checkEoiStatus, onBack, ref, onUnmounted, computed, onMounted, get store() { return store }, get router() { return router }, HeaderCustomer, EOIInfoMessage, LotCard, get formatStripePrice() { return formatStripePrice }, get EstateInterface() { return EstateInterface }, get EoiStatus() { return EoiStatus }, get POSITION() { return POSITION }, get useToast() { return useToast }, CheckboxInput, get LotInterface() { return LotInterface }, get changePrimaryColor() { return changePrimaryColor }, get resetPrimaryColor() { return resetPrimaryColor }, AttentionModal, get isLogged() { return isLogged }, get getUserRole() { return getUserRole }, get changePrimaryColorEoiViews() { return changePrimaryColorEoiViews } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})